import { Collapse, Drawer } from 'antd';
import AppButton from 'components/libs/button';
import React, { useState } from 'react';
import docs from '../../../../assets/images/app/docs_icon.png';
import arrowDown from '../../../../assets/images/app/faq_arrow_down.svg';
import arrowUp from '../../../../assets/images/app/faq_arrow_up.svg';

const { Panel } = Collapse;

interface LinkItem {
    idDoc: string;
    title: string;
    url: string;
}

interface SectionItem {
    _id: string;
    topic: string;
    title: string;
    links: LinkItem[];
}

interface DataAccordionDrawerProps {
    data: SectionItem[];
}

const DataAccordionDrawer: React.FC<DataAccordionDrawerProps> = ({ data }) => {

    const [visible, setVisible] = useState(false);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
    const handleResize = () => {
        setIsMobile(window.innerWidth <= 767);
    };
    window.addEventListener('resize', handleResize);

    const showDrawer = () => {
        setVisible(true);
    };

    const onClose = () => {
        setVisible(false);
    };

    const [activeKey, setActiveKey] = useState<string | string[]>([]); // Tracks open panels

    const handlePanelChange = (key: string | string[]) => {
        setActiveKey(key);
    };

    return (
        <>
            <AppButton onClick={showDrawer}>
                <img src={docs} width={15} style={{ marginRight: "10px" }} />
                Annales
            </AppButton>
            <Drawer
                title="Annales"
                placement="right"
                width={isMobile ? "100%" : "35%"}
                closable={isMobile ? true : false}
                onClose={onClose}
                visible={visible}
                style={{ borderRadius: "0px", border: "none" }}
                bodyStyle={{ borderRadius: "0px", border: "none" }}

            >
                <Collapse accordion style={{ borderRadius: "0px" }} activeKey={activeKey} onChange={handlePanelChange}>
                    {data.map((section, sectionIndex) => {

                        const isPanelOpen =
                            Array.isArray(activeKey)
                                ? activeKey.includes(String(sectionIndex))
                                : activeKey === String(sectionIndex);

                        return (<Panel header={<div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", padding: "20px", borderRadius: "0px", paddingLeft: "7px" }}>{section.title} <img src={isPanelOpen ? arrowUp : arrowDown} height={10}></img></div>} key={sectionIndex} showArrow={false}>
                            {section.links.map((link, linkIndex) => (
                                <div key={linkIndex} style={{ marginTop: "7px" }}><a href={link.url} target='blank' style={{ color: "#707070" }}>{link.title}</a></div>
                            ))}
                        </Panel>)
                    })}
                </Collapse>
            </Drawer>
        </>
    );
};

export default DataAccordionDrawer;
